module.exports = "<Header></Header>\r\n<main>\r\n    <router-outlet></router-outlet>\r\n</main>\r\n<Footer></Footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main